import { Check, X } from "lucide-react";
import { PASSWORD_RULES, ruleResults, strengthFor } from "../../utils/passwordPolicy";

// Four-segment strength bar plus the live rule checklist. Rendered under every
// field where a new password is chosen.
//
// `alwaysVisible` keeps the checklist on screen before anything is typed, so a
// form laid out around it does not jump once the user starts.
const PasswordStrengthMeter = ({
  password = "",
  showRules = true,
  alwaysVisible = false,
  className = "",
}) => {
  if (!password && !alwaysVisible) return null;

  const { score, label, barClass, textClass } = strengthFor(password);
  const rules = ruleResults(password);

  return (
    <div className={`${alwaysVisible ? "" : "mt-2"} ${className}`}>
      <div className="flex items-center gap-2">
        <div className="flex h-1.5 flex-1 gap-1">
          {PASSWORD_RULES.slice(0, 4).map((_, index) => (
            <div
              key={index}
              className={`h-full flex-1 rounded-full transition-colors ${
                password && index <= score ? barClass : "bg-gray-200"
              }`}
            />
          ))}
        </div>
        <span
          className={`text-[11px] font-semibold ${password ? textClass : "text-gray-400"}`}
        >
          {password ? label : "No password"}
        </span>
      </div>

      {showRules && (
        <ul className="mt-2.5 space-y-1.5">
          {rules.map((rule) => (
            <li
              key={rule.id}
              className={`flex items-center gap-1.5 text-xs ${
                rule.met ? "text-success-700" : "text-gray-500"
              }`}
            >
              {rule.met ? (
                <Check size={13} className="shrink-0" />
              ) : (
                <X size={13} className="shrink-0 text-gray-400" />
              )}
              <span>{rule.label}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PasswordStrengthMeter;
